import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './AppRoutes';
import RouterUtils from './RouterUtils';

const AppRouter = () => (
	<BrowserRouter>
		<RouterUtils>
			<AppRoutes />
		</RouterUtils>
	</BrowserRouter>
);

export default AppRouter;
